import React, { Component } from "react";
import { Breadcrumb, Button, Pagination, Radio, Skeleton, Slider } from "antd";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import { Link, withRouter } from "react-router-dom";
import { Collapse, Checkbox } from "antd";
import "./Category.scss";
import { connect } from "react-redux";
import {
  FilterOutlined,
  CloseOutlined
} from '@ant-design/icons';
import ProductCard from "../../components/ProductCard/ProductCard";
import { fetchBrand, fetchFilterData, getLvl1Categories, getCategoryProducts, fetchSearch } from "../../network/product.network";
import { clearCart } from "../../redux/cart/cart.action";
import localization from '../../Localization/Localization.json'
import { fallbackImg } from "../../constants/constants";
import NoProducts from "../../components/NoProducts/NoProducts";
import ResNavBar from "../../components/ResNavBar/ResNavBar";
const { Panel } = Collapse;
const plainOptions = ["Maybelline", "dior", "adidas", "L'Oréal"];


class Category extends Component {
  state = {
    PriceRange: [0, 1000], 
    // categoryProducts : [],
    categoryProducts : [],
    categoryLevels : [],
    loading : true,
    filterLoading : false,
    sortVal : false,
    filterData : null,
    filterDataChecked : [],
    categoryShow : null,
    paginationList : [] 
  };
  
  onChangeSlider = (value) => {
    this.setState({ PriceRange: value });
    // this.handelFilterData(true);
  };

  componentWillUnmount() { 
      this.unlisten();
  }

  componentDidMount() {
    const { match, location } = this.props;

    this.unlisten = this.props.history.listen((location, action) => {
      console.log(location)
      if(location.pathname.includes('/search')){
        setTimeout(() => {
          const { match } = this.props; 
          this.setState({loading : true})
          let params = `${match.params.name}`;   
            console.log(params); 
            fetchSearch(
              params, 
              (res) => {
                console.log(res); 
                this.setState({loading : false, categoryProducts : res.data.data.products, pagination : res.data.data.pagination, categoryShow : "brand"})  
              },
              (error) => {console.log(error); this.setState({loading : false}) }
            )
          
        }, 400)
      }
      if(location.pathname.includes('/brand')){
        this.setState({loading : true})
        setTimeout(() => {
          const { match } = this.props; 
          let params = `${match.params.name}`;  
          this.setState({filterDataChecked : [`${match.params.id}`]}) 
            console.log(params); 
            fetchSearch(
              params, 
              (res) => {
                console.log(res); 
                this.setState({loading : false, categoryProducts : res.data.data.products, pagination : res.data.data.pagination, categoryShow : "brand"})  
              },
              (error) => {console.log(error); this.setState({loading : false}) }  
            )
          
        }, 400)
      }
    });

    fetchFilterData(
      (res) => {
        console.log(res.data.data); 
        this.setState({filterData : res.data.data, filterLoading : false})
      },
      (error) => {console.log(error); this.setState({filterLoading : false}) }
    )
    this.handelSectionRouteData();
  }

  handelSectionRouteData = (page) => {
    const { match, location } = this.props;
    const { pagination } = this.state;
    
    if(location.pathname.includes('/brand/')){
      // in brand section
      this.setState({categoryShow : "brand"})
      let params = "";
      params += `brandIds[0]=${match.params.id}`;
      console.log(params); 
      fetchBrand(
        params, 
        (res) => {
          this.setState({categoryProducts : res.data.data.products, pagination : res.data.data.pagination, categoryInfo : res.data.data.category, loading : false})
          setTimeout(() => {
            this.setState({filterDataChecked : [`${match.params.id}`]}) 
          }, 1000)
          
        },
        (error) => {console.log(error); this.setState({loading : false}) }
      )
    }else if(location.pathname.includes('/level/')){
      console.log(match);
      // /level/:catID/:id/:name
      this.setState({loading : true}) 
      let body = new FormData();
      body.append("categoryId", `${match.params.id}`); 
      body.append("level", `2`);
      if(pagination?.totalPages > 1 && page){
        body.append("page", page); 
      }
      getCategoryProducts(
        body,  
        (res) => { 
          this.setState({ 
            categoryProducts : res.data.data.products, 
            categoryInfo : res.data.data.category,
            pagination : res.data.data.pagination,
            paginationList : [
              {name : `${match.params.catName}`, route : `/category/${match.params.catID}/${match.params.catName}`},
              {name : `${match.params.name}`, route : `/level/${match.params.catID}/${match.params.catName}/${match.params.id}/${match.params.name}`}, 
            ], 
            categoryLevels : res.data.data.category.level3Categories || [], loading : false
          }) 
        },
        (error) => {console.log(error); this.setState({loading : false})}
      )
    } else if(location.pathname.includes('/subLevel/')){
      console.log(match);
      this.setState({loading : true, categoryShow : "level3"}) 
      let body = new FormData();
      body.append("categoryId", `${match.params.id}`);  
      body.append("level", `3`);
      if(pagination?.totalPages > 1 && page){
        body.append("page", page); 
      }
      getCategoryProducts(
        body,  
        (res) => { 
          this.setState({ 
            categoryProducts : res.data.data.products, 
            categoryInfo : res.data.data.category,
            pagination : res.data.data.pagination,
            paginationList : [
              {name : `${match.params.catName}`, route : `/category/${match.params.catID}/${match.params.catName}`},
              {name : `${match.params.lvlName}`, route : `/level/${match.params.catID}/${match.params.catName}/${match.params.lvlID}/${match.params.lvlName}`}, 
              {name : `${match.params.name}`, route : `/subLevel/${match.params.catID}/${match.params.catName}/${match.params.lvlID}/${match.params.lvlName}/${match.params.id}/${match.params.name}`}, 
            ], 
            categoryLevels : res.data.data.category.level3Categories || [], loading : false
          }) 
        },
        (error) => {console.log(error); this.setState({loading : false})}
      )
    } else if(location.pathname.includes('/search')){
      console.log(match);
      this.setState({loading : true})
      let params = `${match.params.name}`; 
      if(pagination?.totalPages > 1 && page){ 
        params += `&page=${page}`; 
      }
        console.log(params); 
        fetchSearch(
          params, 
          (res) => {
            console.log(res); 
            this.setState({loading : false, pagination : res.data.data.pagination, categoryProducts : res.data.data.products, categoryShow : "brand"})  
          },
          (error) => {console.log(error); this.setState({loading : false}) }
        )
    }
    else{
      console.log(match.params); 
      let body = new FormData();
      body.append("categoryId", match.params.id);
      if(pagination?.totalPages > 1 && page){
        body.append("page", page); 
      }
      getLvl1Categories(
        body, 
        (res) => { 
          this.setState({ categoryLevels : res.data.data.categories,  
            paginationList : [ {name : `${res.data.data.level1Category.name}`, route : `/category/${res.data.data.level1Category.id}`}]}, () => { 
            body.append("level", res.data.data.level1Category.level);
            getCategoryProducts(
              body, 
              (res) => { 
                this.setState({ categoryInfo : res.data.data.category, pagination : res.data.data.pagination , categoryProducts : res.data.data.products, loading : false})
              },
              (error) => {console.log(error); this.setState({loading : false})} 
            )
          }) 
        },
        (error) => {console.log(error);}
      )
    }

  }

  handelLvl2Product = (lvl) => {
    // console.log(lvl);
    this.setState({loading : true}) 
    let body = new FormData();
    body.append("categoryId", lvl.id);  
    body.append("level", lvl.level);
    getCategoryProducts(
      body,  
      (res) => { 
        this.setState({ 
          categoryProducts : res.data.data.products, 
          categoryLevels : res.data.data.category.level3Categories || [], loading : false,
          paginationList : [...this.state.paginationList, {name : `${lvl.name}`, route : `/category/${lvl.id}/level/${lvl.level}`}],
        })
        // this.props.history.replace(`/category/level/${res.data.data.category.id}`) 
      },
      (error) => {console.log(error); this.setState({loading : false})}
    )
  }

  
  handelSelectLvl = (lvl) => {
    // console.log("lvllvllvllvl",lvl);  
    const { match } = this.props;
    console.log(match); 
    if(lvl.level === 2){
      // /level/:catID/:catName/:id/:name 
      this.props.history.push(`/level/${match.params.id}/${match.params.name}/${lvl.id}/${lvl.name}`) 
    }else if(lvl.level === 3){
      // /subLevel/:catID/:id/:name
      // /subLevel/:catID/:catName/:lvlID/:lvlName/:id/:name
      this.props.history.push(`/subLevel/${match.params.catID}/${match.params.catName}/${match.params.id}/${match.params.name}/${lvl.id}/${lvl.name}`)    
    }
  } 

  componentDidUpdate(prevProps, prevState) {
    
  }

  onChangeFilterData = (checkedValues) => {
    console.log(checkedValues); 
    this.setState({filterDataChecked : checkedValues, categoryShow : "brand"}, () => {
      this.handelFilterData();
    }) 
  }

  handelFilterData = (withPrice = false) => {
    const {filterDataChecked, PriceRange, sortVal} = this.state;
    this.setState({loading : true})
    let params = "";
    filterDataChecked.forEach((data, idx) => {
      params += `brandIds[${idx}]=${data}&`; 
    })
    if(withPrice){
      this.setState({filterLoading : true})
      params += `priceFrom=${PriceRange[0]}&`;
      params += `priceTo=${PriceRange[1]}&`; 
    }
    if(sortVal){
      params += `sort=${sortVal}&`; 
    }
    console.log(params);
    fetchBrand(
      params, 
      (res) => { 
        this.setState({categoryProducts : res.data.data.products, pagination : res.data.data.pagination, loading : false, filterLoading : false})
      },
      (error) => {console.log(error); this.setState({loading : false, filterLoading : false}) }
    )
  }

  onChangePagination = (page ) => {
    console.log(page)
    this.handelSectionRouteData(page); 
  }

  handelOpenResFilter = (openMenu = true) => {
    if(openMenu){
        document.getElementsByClassName("category-aside-holder")[0].classList.add("active");
    }else{
        document.getElementsByClassName("category-aside-holder")[0].classList.remove("active");
    }
}

onChangeSort = (checkedValues) => {
  console.log("checked = ", checkedValues.target.value);
  this.setState({sortVal : checkedValues.target.value}, () =>{
    this.handelFilterData();
  })
}

  render() {
    const {paginationList, PriceRange, categoryProducts, categoryInfo, loading, filterData, filterDataChecked, categoryShow, filterLoading, categoryLevels, pagination } = this.state;
    const { currentLang, match } = this.props;
    const options = [ 
      { label: localization.Pricelowest[currentLang], value: 1 },
      { label: localization.Pricehighest[currentLang], value: 2 },
      { label: localization.Mostrelevant[currentLang], value: 3 },
      { label: localization.MostPopular[currentLang], value: 4 },
      { label: localization.AZ[currentLang], value: 5 }, 
      { label: localization.ZA[currentLang], value: 6 },
    ]; 
    
    return (
      <div className="category-page-wrapper">
        <Header />
        <div className="category-hero">
          <h2>{categoryInfo?.name}</h2>
        </div>
        <div className="container">
          <div className="category-page-content">
            <Breadcrumb separator=">">
              <Breadcrumb.Item>
                <Link to="/">{localization.home[currentLang]}</Link>
              </Breadcrumb.Item>
              {categoryShow === "brand" ? 
              <Breadcrumb.Item>
                {match.params.name}
              </Breadcrumb.Item> : (
                paginationList.map(pagination => 
                  <Breadcrumb.Item>
                    <Link to={pagination.route}>{pagination.name}</Link> 
                  </Breadcrumb.Item>
                  )
                )
            }
            </Breadcrumb>
            <div className={`category-view-wrapper ${categoryShow === "brand" && " is-brand"} ${categoryShow === "level3" && " is-brand"}`}> 
              <aside className="category-aside-holder">
                <div className="category-filter-holder">
                  <div className="filter-section">
                  <CloseOutlined className="close-filter-slide" onClick={() => this.handelOpenResFilter(false)} />
                    <Collapse defaultActiveKey={["1"]} ghost>
                      <Panel header={localization.Sortby[currentLang]} key="1">
                        <Radio.Group size="large" options={options} onChange={this.onChangeSort} /> 
                      </Panel>
                      <Panel header={localization.Filterby[currentLang]} key="2">
                        <Checkbox.Group  
                          options={filterData?.brands?.map(brand => ({label : ""+brand.name, value : ""+brand.id}) )} 
                          onChange={this.onChangeFilterData}
                          value={filterDataChecked} 
                        />
                      </Panel>
                      <Panel header={localization.Price[currentLang]} key="3">
                        <Slider
                          min={0}
                          max={1000}
                          range={{ draggableTrack: true }} 
                          defaultValue={[0, 1000]}
                          onChange={this.onChangeSlider}
                        />
                        <div className="slider-price-rang">
                          <p className="price-start">{localization.AED[currentLang]} {PriceRange[0]}</p>
                          <p className="price-end">{localization.AED[currentLang]} {PriceRange[1]}</p>
                        </div>
                      </Panel>
                    </Collapse>
                      <Button 
                          loading={filterLoading} 
                          type="primary" 
                          size="large" 
                          style={{marginTop : 20}}
                          block onClick={() => this.handelFilterData(true)}>{localization.Filter[currentLang]}</Button>  
                  </div>
                </div>
              </aside>
              <div className="category-list-holder"> 
                {categoryShow !== "brand" &&
                <div className="category-sections-holder">
                  {categoryLevels.map((section) => ( 
                      <div className="section-holder" key={section.id} onClick={() => this.handelSelectLvl(section)} > 
                        <img src={section.image || fallbackImg} alt={section.name} />
                        <p className="section-title">{section.name}</p>
                      </div>
                  ))}
                </div> 
                }
                <div className="cat-header-title-filter">
                <h4 className="section-title"> { categoryShow === "brand" ? match.params.name : categoryInfo?.name && `${categoryInfo?.name} ${localization.Products[currentLang]}` }</h4>   
                <FilterOutlined onClick={this.handelOpenResFilter} />
                </div>
                <div className="category-product-wrapper"> 
                  {!loading
                    ? categoryProducts.length > 0 ? categoryProducts.map((card) => (
                        <ProductCard discount card={card} />
                      )) : <NoProducts /> 
                    : [0, 0, 0, 0].map((skl) => (
                        <Skeleton avatar active paragraph={{ rows: 4 }} />
                      ))}
                </div> 
                {pagination && pagination?.totalPages > 1 && 
                <div className="pagination-wrapper">    
                  <Pagination responsive 
                  onChange={this.onChangePagination}
                  current={pagination?.current} pageSize={pagination?.size} total={pagination?.total} /> 
                </div>
                }
              </div>
            </div>
          </div>
        </div>
        <Footer />
        <ResNavBar /> 
      </div>
    );
  }
}

const categoryWithRouter = withRouter(Category);
const mapStateToProps = (state) => ({
  productsList: state.products.productsList, 
  currentLang : state.user.currentLang,
});
export default connect(mapStateToProps)(categoryWithRouter);
